import * as React from "react";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import { Redirect } from "react-router";
import axios from "../../helpers/axios";
import { Pagination,ButtonGroup } from "@mui/material";
import Highcharts from "highcharts";
import { formatDate, formatTime, isEmailAllowed } from "../../helpers/custom";
import {
  format,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  subMonths
} from "date-fns";
import {
  Grid,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Modal,
  Box,
  Divider,
  FormControl,
  Select,
  InputLabel,
  TextField,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation, WithTranslation } from "react-i18next";
import DiversionHeader from "./DiversionHeader";
import {
  DataGrid,
  GridRowParams,
  GridActionsCellItem,
  GridCellParams,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import {
  EditOutlined,
  Add,
  Security as SecurityIcon,
  FileCopy as FileCopyIcon,
  MoreHorizOutlined,
  CloseOutlined,
} from "@mui/icons-material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import fileDownload from "js-file-download";

import newURL from "../../helpers/newUrl";
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "65%",
  p: 4,
};
function CustomPagination({
  count,
  page,
  onChange,
}: {
  count: number;
  page: number;
  onChange: (event: React.ChangeEvent<unknown>, value: number) => void;
}) {
  return (
    <Pagination
      count={count}
      page={page}
      onChange={onChange}
      color="primary"
      shape="rounded"
      variant="outlined"
      showFirstButton
      showLastButton
    />
  );
}

function CustomToolbar() {
  return (
    <GridToolbarContainer className="exportButton">
      <GridToolbarExport
        variant="contained"
        csvOptions={{ fileName: "Diverted-waste" }}
      />
    </GridToolbarContainer>
  );
}

export interface IProps {
  user: {
    id: number;
    name: string;
    email: string;
    role: string;
    is_active: boolean;
    selectedHierarchies: any[];
    selectedHierarchyIds: any[];
  };
}

export interface IState {
  showLoader: boolean;
  pageSize: number;
  rowCount: number;
  filter: string;
  filter_route_id: any;
  sortedWasteList: any[];
  materialGraphData: any[],
  sorting_agents: any[];
  material_types: any;
  material_types_raw: any;
  showCustomDateFilter: boolean;
  graphViewType:string;
  customFromDate?: string | null;
  customToDate?: string | null;
  durationType: string;
  types: any[];
  routes: any[];
  anchorEl: any;
  showAddWasteByRawMaterial: boolean;
  showAddWasteByMassUpload: boolean;
  showMaterialGraph: boolean;
  graphDuration: string;
  showGraphCustom: boolean;
  graphFrom: string | null;
  graphTo: string | null;
  /**Add waste by Vehicle Form Data */
  agent_id?: any;
  route_id?: any;
  unit?: string;
  date?: string | null;
  time?: string | null;
  vehicle_id?: any;
  vehicle_capacity?: any;
  percent_full?: number;
  total_waste?: number;
  recyclables_percentage?: number;
  recyclables_kg?: number;
  organics_percentage?: number;
  organics_kg?: number;
  residual_percentage?: number;
  residual_kg?: number;
  material?: any;
  material_type?: any;
  waste_quantity?: number;
  description: string;
  /**Add waste by Vehicle Form Data */
  showExportToCsv: boolean;
  fromDate?: string | null;
  toDate?: string | null;
  graphCustomFromDate: string|null,
  graphLoading: boolean;
  dateFilterLoading: boolean;
  graphCustomToDate:string| null,
  units: any[];
  entryId: string;
  sortedWasteId: string;
  showDeleteDialog: boolean;
  currentPage: number;
}

class DivertedWaste extends React.Component<
  RouteComponentProps & IProps & WithTranslation,
  IState
> {
  constructor(props: RouteComponentProps & IProps & WithTranslation) {
    super(props);
    this.state = {
      showLoader: false,
      pageSize: 10,
      currentPage: 0,
      rowCount: 0,
      filter: "",
      filter_route_id: "all",
      sortedWasteList: [],
      sorting_agents: [],
      material_types: [],
      material_types_raw: {},
      showMaterialGraph: false,
      graphDuration: "current_month",
      dateFilterLoading: false, 
      showGraphCustom: false,
      graphViewType: "material",
      graphFrom: null,
      graphTo: null,
      types: [],
      routes: [],
      anchorEl: null,
      showCustomDateFilter: false,
      materialGraphData: [],
      customFromDate: null,
      customToDate: null,
      durationType: "",
      showAddWasteByRawMaterial: false,
      graphCustomFromDate: null,
      graphCustomToDate: null,
      showAddWasteByMassUpload: false,
      agent_id: "",
      route_id: "",
      date: null,
      time: formatDate(
        formatDate(new Date(), "Y-m-d") + " 00:00:00",
        "Y-m-d H:i:s"
      ),
      total_waste: 0,
      description: "",
      showExportToCsv: false,
      fromDate: null,
      toDate: null,
      units: [],
      graphLoading: false,
      entryId: "",
      sortedWasteId: "",
      showDeleteDialog: false,
    };
  }
  public componentDidMount(): void {
    this.fetchSortedWasteList();
    this.fetchRoutes();
    this.fetchUnits();
    this.fetchAgents();
    this.fetchMaterialTypes();
  }
  // componentDidUpdate (prevProps:any, prevState:any) {
  //     if (!prevState.showMaterialGraph && this.state.showMaterialGraph) {
  
  //         setTimeout(() => {
  //             this.renderMaterialGraph();
  //         }, 50);
  //     }
  // }
  
   renderMaterialGraph() {
    const container = document.getElementById("incomingGraphContainer");
  if (!container) return;   
  const data = this.state.materialGraphData;
  if (!data || data.length === 0) {
    Highcharts.chart(container, {
      title: {
        text: "No data available",
        y: 180, 
        style: { color: "#999", fontSize: "16px" }
      },
      credits: { enabled: false }
    });
    return;
  }

   const fallbackColors = [
  "#3B3EAC", "#56B1BF", "#FE9C78", "#C84B31", "#FFC85B", "#2F2E41", "#7C9797", "#CCA85A", "#FF8F66"
];

  const hcColors = fallbackColors;

  const materialTypes = data.map((item: any) => item.type);
  const series: any[] = [];

  let colorIndex = 0;

  data.forEach((item: any, typeIndex: number) => {
    [...(item.subtypes|| [])].reverse().forEach((sub: any) => {
      series.push({
        type: "bar",
        name: sub.subtype,
        data: data.map((_: any, rIndex: number) =>
          rIndex === typeIndex ? sub.total : null
        ),
        color: hcColors[colorIndex % hcColors.length],
      });
      colorIndex++;
    });
  });

  Highcharts.chart(container, {
    chart: { type: "bar", height: 450 },
    title: { text: "" },

    legend: { enabled: false },

    xAxis: { categories: materialTypes },
    // yAxis: { min: 0, title: { text: "Values" } },
    yAxis: {
      min: 0,
      title: { text: "Values" },

      stackLabels: {
        enabled: true,
        allowOverlap: false,
        crop: true,
        overflow: "justify",

        formatter: function () {
          const ctx = this as any;
          const text = ctx.total ? ctx.total.toLocaleString() : "";

          // Optional: hide very large totals if needed
          // return text.length > 6 ? "" : text;
          return text;
        },

        style: {
          fontWeight: "bold",
          color: "#000",
          fontSize: "12px",
        },

        x: 10   // spacing after bar
      }
    },


    plotOptions: {
      bar: {
        stacking: "normal",

        pointPadding: 0.1,
        groupPadding: 0.2,
        borderRadius: 3,
        borderWidth: 0,

        pointWidth: 35,
        // minPointLength: 25, 

        dataLabels: {
          enabled: true,
          inside: true,
          allowOverlap: false,
          crop: true,
          formatter: function () {
            const ctx = this as any;
            const point = ctx.point as Highcharts.Point & {
              shapeArgs?: { height?: number };
            };

            if (!point.shapeArgs?.height) return null;

            // In bar charts, height is the usable space
            const barSize = point.shapeArgs.height;

            const text = String(ctx.y.toLocaleString());
            const textSize = text.length * 7; // approx px width

            return textSize + 6 < barSize ? text : null;
          },


          style: {
            color: "#ffffff",
            fontSize: "12px",
            fontWeight: "bold",
            textOutline: "none",
          },
        },
      },
    },


    tooltip: {
      formatter: function (this: any) {
        return `
                <b>${this.series.name}</b><br/>
                Value: <b>${this.y.toLocaleString()}</b>
              `;
      },
    },

    series,
  });
}
 renderTimeGraph() {
  const container = document.getElementById("incomingGraphContainer");
  if (!container) return;

  const data = this.state.materialGraphData;

  if (!data || data.length === 0) {
    Highcharts.chart(container, {
      title: {
        text: "No data available",
        y: 180,
        style: { color: "#999", fontSize: "16px" }
      },
      credits: { enabled: false }
    });
    return;
  }

  const fallbackColors = [
    "#3B3EAC", "#56B1BF", "#FE9C78", "#C84B31",
    "#FFC85B", "#2F2E41", "#7C9797",
    "#CCA85A", "#FF8F66"
  ];

  const dates = data.map((d: any) => {
    const raw = d.date;
    if (raw.length === 7) {
      return format(new Date(raw + "-01"), "MMM yyyy");
    }
    return format(new Date(raw), "MMM dd");
  });

  const materialSet = new Set<string>();
  data.forEach((d: any) => {
    d.materials.forEach((m: any) => materialSet.add(m.type));
  });

  const materials = Array.from(materialSet);
  let colorIndex = 0;

  const series: any[] = materials.map((material) => {
    const color = fallbackColors[colorIndex % fallbackColors.length];
    colorIndex++;

    return {
      type: "bar",
      name: material,
      color: color,
      data: data.map((dateItem: any) => {
        const found = dateItem.materials.find((m: any) => m.type === material);
        return found ? found.type_total : 0;
      })
    };
  });

  const barHeight = 50; 
  const calculatedHeight = Math.max(450, dates.length * barHeight);

  Highcharts.chart(container, {
    chart: { 
      type: "bar", 
      height: calculatedHeight 
    },
    title: { text: "" },
    legend: { enabled: false },
    credits: { enabled: false },

    xAxis: {
      categories: dates
    },

    yAxis: {
      min: 0,
      title: { text: "Values" },

      stackLabels: {
        enabled: true,
        allowOverlap: false,
        crop: true,
        overflow: "justify",
        formatter: function () {
          const ctx = this as any;
          return ctx.total ? ctx.total.toLocaleString() : "";
        },
        style: {
          fontWeight: "bold",
          color: "#000",
          fontSize: "12px"
        },
        x: 10
      }
    },

    plotOptions: {
      bar: {
        stacking: "normal",
        pointPadding: 0.1,
        groupPadding: 0.2,
        borderRadius: 3,
        borderWidth: 0,
        pointWidth: 35, 

        dataLabels: {
          enabled: true,
          inside: true,
          allowOverlap: false,
          crop: true,
          formatter: function () {
            const ctx = this as any;
            const point = ctx.point as any;

            if (!point.shapeArgs?.height) return null;

            const barSize = point.shapeArgs.height;
            const text = String(ctx.y.toLocaleString());
            const textSize = text.length * 7;

            return textSize + 6 < barSize ? text : null;
          },
          style: {
            color: "#ffffff",
            fontSize: "12px",
            fontWeight: "bold",
            textOutline: "none"
          }
        }
      }
    },

    tooltip: {
      formatter: function () {
        const ctx = this as any;
        const dateIndex = ctx.point.index;
        const dateData = data[dateIndex];

        const materialData = dateData.materials.find(
          (m: any) => m.type === ctx.series.name
        );

        let subtypeHtml = "";
        if (materialData) {
          materialData.subtypes.forEach((s: any) => {
            subtypeHtml += `${s.subtype}: ${s.total.toLocaleString()}<br/>`;
          });
        }

        return `
          <b>${ctx.series.name}</b><br/>
          Total: <b>${ctx.y.toLocaleString()}</b><br/><br/>
          ${subtypeHtml}
        `;
      }
    },

    series
  });
}

  public fetchSortedWasteTypeSummary() {
     this.setState({ graphLoading: true });
  const params: any = {
    hierarchies: this.props.user.selectedHierarchyIds,
    start_date: this.state.customFromDate
      ? formatDate(this.state.customFromDate, "Y-m-d")
      : "",
    end_date: this.state.customToDate
      ? formatDate(this.state.customToDate, "Y-m-d")
      : "",
      group_by: this.state.graphViewType ,
  };

  axios
    .get("sortedWasteTypeSummary", { params })
    .then((res: any) => {
      this.setState({ materialGraphData: res.data.data|| [],
        graphLoading: false ,
        dateFilterLoading: false}, () => {
        // this.renderMaterialGraph();
        if (this.state.graphViewType === "material") {
            this.renderMaterialGraph();
          } else {
            this.renderTimeGraph();   
          }
      });
    })
    .catch((err) => {
      this.setState({ graphLoading: false, materialGraphData: [] , dateFilterLoading: false});
      toast.error("Failed to load graph data");
    });
}

  public fetchSortedWasteList(
    page: number = 0,
    limit: number = this.state.pageSize
  ) {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: true, currentPage: page });
      let selectedRoute = this.state.filter_route_id
        ? this.state.routes[this.state.filter_route_id]
        : {};
      let options: any = {
        hierarchies: this.props.user.selectedHierarchyIds,
        filter: this.state.filter,
        id: "all",
        page: page + 1,
        limit: limit,
        start_date: this.state.customFromDate
          ? formatDate(this.state.customFromDate, "Y-m-d")
          : "",
        end_date: this.state.customToDate
          ? formatDate(this.state.customToDate, "Y-m-d")
          : "",
      };
      if (this.state.filter_route_id && this.state.filter_route_id != "all") {
        options["selectedDropDown[id]"] = this.state.filter_route_id
          ? selectedRoute.id
          : "";
        options["selectedDropDown[hierarchy_id]"] = this.state.filter_route_id
          ? selectedRoute.hierarchy_id
          : "";
      } else {
        options["selectedDropDown"] = "";
      }
      axios
        .get(`sortedWasteList`, { params: options })
        .then((response: any) => {
          this.setState({ showLoader: false });
          let data: any = response.data.data.data;
          let sortedWasteList: any = [];
          data.map((sortedWaste: any) => {
            sortedWasteList.push({
              id: sortedWaste.id,
              route: sortedWaste.route_name,
              route_id: sortedWaste.route_id,
              hierarchy_id: sortedWaste.hierarchy_id,
              type: sortedWaste.sorted_waste_for_storage_type,
              type_id: sortedWaste.sorted_waste_for_storage_type_id,
              weight: sortedWaste.quantity,
              unit: sortedWaste.unit,
              unit_id: sortedWaste.unit_id,
              material: sortedWaste.sorted_waste_for_storage_type_material,
              sorting_agent: sortedWaste.sorting_agent_name,
              kind_of_sorted_wastes: sortedWaste.kind_of_sorted_wastes,
              sorting_agent_id: sortedWaste.sorting_agent_id,
              description: sortedWaste.description,
              created_at: sortedWaste.created_at,
              updated_at: sortedWaste.updated_at,
            });
          });
          this.setState({
            sortedWasteList: sortedWasteList,
            rowCount: response.data.data.total,
          });
        })
        .catch((error) => {
          this.setState({
            showLoader: false,
          });
          toast.error(error.response.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  }

  public fetchRoutes() {
    axios
      .get(`allCommunitiesWithHierarchyLite`, {
        params: { hierarchies: this.props.user.selectedHierarchyIds },
      })
      .then((response) => {
        let data: any = response.data.data;
        let routes: any = [];
        let hierarchies: any = [];
        data.map((route: any) => {
          if (!hierarchies[route.hierarchy_id]) {
            hierarchies[route.hierarchy_id] = {
              id: route.hierarchy_id,
              name: route.hierarchy_name,
              routes: [],
            };
            hierarchies[route.hierarchy_id].routes.push({
              type: "route",
              id: route.id,
              route: route.name,
              hierarchy_id: route.hierarchy_id,
              hierarchy_name: route.hierarchy_name,
            });
          } else {
            hierarchies[route.hierarchy_id].routes.push({
              type: "route",
              id: route.id,
              route: route.name,
              hierarchy_id: route.hierarchy_id,
              hierarchy_name: route.hierarchy_name,
            });
          }
        });
        hierarchies.map((hierarchy: any) => {
          routes.push({
            type: "hierarchy",
            id: "all",
            route: hierarchy.name,
            hierarchy_id: hierarchy.id,
            hierarchy_name: hierarchy.name,
          });
          routes.push({
            type: "multiple_routes",
            id: "all",
            route: "Multiple Routes",
            hierarchy_id: hierarchy.id,
            hierarchy_name: hierarchy.name,
          });
          // hierarchy.routes.map((route: any) => {
          //     routes.push({
          //         "type": "route",
          //         "id": route.id,
          //         "route": route.route,
          //         "hierarchy_id": route.hierarchy_id,
          //         "hierarchy_name": route.hierarchy_name
          //     });
          // });
        });
        this.setState({ routes: routes });
      });
  }

  public fetchUnits() {
    axios
      .get(`getUnits`, {
        params: { hierarchies: this.props.user.selectedHierarchyIds },
      })
      .then((response) => {
        let data: any = response.data.data;
        this.setState({ units: data });
      });
  }

  public fetchAgents() {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: true });
      let options = { hierarchies: this.props.user.selectedHierarchyIds };
      axios.get(`allAgentsLite`, { params: options }).then((response: any) => {
        this.setState({ showLoader: false });
        let sorting_agents: any = response.data.data;
        this.setState({ sorting_agents: sorting_agents });
      });
    }
  }

  public fetchMaterialTypes() {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: true });
      let options = { hierarchies: this.props.user.selectedHierarchyIds };
      axios
        .get(`subTypesOfMaterial`, { params: options })
        .then((response: any) => {
          this.setState({ showLoader: false });
          let material_types: any = response.data.data;
          this.setState({ material_types: material_types });
          this.fetchMaterialTypesRaw();
        });
    }
  }

  public fetchMaterialTypesRaw() {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: true });
      let material_types = this.state.material_types;
      let options = { hierarchies: this.props.user.selectedHierarchyIds };
      axios
        .get(`getSortedWasteForStorageType`, { params: options })
        .then((response: any) => {
          this.setState({ showLoader: false });
          let data: any = response.data.data;
          let unit = this.state.units[0].id;
          let material_types_raw: any = {};
          let i = 0;
          Object.keys(data).map(function (key) {
            let item = data[key];
            let subValue: any = {};
            material_types[item].map((subItem: any, key: number) => {
              subValue[key] = {
                typeOfSortedWaste: item,
                subTypesOfMaterialEntry: subItem.id,
                unit: unit,
                quantity: 0,
                edit_uuid: "",
              };
            });
            material_types_raw[i] = {};
            material_types_raw[i]["SubVal"] = subValue;
            i++;
          });
          this.setState({ material_types_raw: material_types_raw });
        });
    }
  }

  public render() {
    if (!localStorage.getItem("token")) {
      return <Redirect to="/login" />;
    }
    const { t } = this.props;
    const open = Boolean(this.state.anchorEl);

    const handleMoreOptions = (event: React.MouseEvent<HTMLElement>) => {
      this.setState({ anchorEl: event.currentTarget });
    };

    const handleExportToCsv = () => {
      const date = new Date();
      const Offset = date.getTimezoneOffset();

      this.setState({ showLoader: false });
      let data: any = {
        startDate: this.state.fromDate
          ? formatDate(this.state.fromDate, "Y-m-d")
          : "",
        endDate: this.state.toDate
          ? formatDate(this.state.toDate, "Y-m-d")
          : "",
        hierarchies: this.props.user.selectedHierarchyIds,
      };
      let url = "/node/new/api/divertedWasteExport";
      if (axios.defaults.baseURL) {
        let currentBaseURL: string = axios.defaults.baseURL;
        currentBaseURL = currentBaseURL.split("/").slice(0, 3).join("/");
        url = currentBaseURL + url;
      }
      axios({
        url:
          url +
          "/" +
          data.startDate +
          "/" +
          data.endDate +
          "/" +
          data.hierarchies +
          "/" +
          Offset,
        method: "GET",
        responseType: "blob", // important
      })
        .then((response) => {
          var fileName =
            "divertedWaste" + data.startDate + "_" + data.endDate + ".csv";
          fileDownload(response.data, fileName);
          if (response.data.success) {
            toast.success(response.data.success, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ showLoader: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleClearAddWasteByRawMaterial = () => {
      this.setState({
        showAddWasteByRawMaterial: false,
        entryId: "",
        route_id: "",
        waste_quantity: 0,
        unit: "",
        agent_id: "",
        material: "",
        material_type: "",
        date: null,
        time: formatDate(
          formatDate(new Date(), "Y-m-d") + " 00:00:00",
          "Y-m-d H:i:s"
        ),
        description: "",
        types: [],
        showLoader: false,
      });
    };

    const handleAddWasteByRawMaterial = (event: any) => {
      event.preventDefault();
      this.setState({ showLoader: true });
      let datetime: any = this.state.date
        ? formatDate(this.state.date, "Y-m-d") +
          " " +
          (this.state.time ? formatTime(this.state.time, "H:i:s") : "00:00:00")
        : "";
      let data: any = {
        route: this.state.routes[this.state.route_id],
        quantity: this.state.waste_quantity,
        unit: this.state.unit,
        sorted_agent_id: this.state.agent_id,
        // typeOfSortedWasteMaterialList: this.state.material,
        typeOfSortedWaste: this.state.material_type,
        datetime: datetime,
        description: this.state.description,
      };
      if (this.state.entryId) {
        data.id = this.state.entryId;
        // data.community_id = this.state.route_id;
        data.typeOfSortedWasteMaterial = this.state.material;
      } else {
        // data.route = this.state.routes[this.state.route_id];
        data.typeOfSortedWasteMaterialList = this.state.material;
      }
      axios
        .post(`addUpdateSortedWaste`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            handleClearAddWasteByRawMaterial();
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchSortedWasteList();
          } else {
            handleClearAddWasteByRawMaterial();
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
            this.fetchSortedWasteList();
          }
        })
        .catch((error) => {
          handleClearAddWasteByRawMaterial();
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleMassUploadDataChange = (
      key: number,
      subKey: number,
      fieldName: string,
      value: any
    ) => {
      let massUploadData = this.state.material_types_raw;
      if (massUploadData[key]) {
        massUploadData[key]["SubVal"][subKey][fieldName] = value ? value : null;
      }
      this.setState({ material_types_raw: massUploadData });
    };

    const handleAddWasteByMassUpload = (event: any) => {
      event.preventDefault();
      this.setState({ showLoader: true });
      let datetime: any = this.state.date
        ? formatDate(this.state.date, "Y-m-d") +
          " " +
          (this.state.time ? formatTime(this.state.time, "H:i:s") : "00:00:00")
        : "";
      let data: any = {
        Val: this.state.material_types_raw,
        sorted_agent_id: this.state.agent_id,
        route: this.state.routes[this.state.route_id],
        datetime: datetime,
        unit: this.state.units[0].id,
        hierarchies: this.props.user.selectedHierarchyIds,
      };
      newURL
        .post(`addUpdateSortedWasteMassUpload`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState(
              {
                showAddWasteByMassUpload: false,
                agent_id: "",
                route_id: "",
                date: null,
                time: formatDate(
                  formatDate(new Date(), "Y-m-d") + " 00:00:00",
                  "Y-m-d H:i:s"
                ),
                showLoader: false,
              },
              () => {
                this.fetchMaterialTypesRaw();
              }
            );
            toast.success(response.data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });

            this.fetchSortedWasteList();
          } else {
            this.setState(
              {
                showAddWasteByMassUpload: false,
                agent_id: "",
                route_id: "",
                date: null,
                time: formatDate(
                  formatDate(new Date(), "Y-m-d") + " 00:00:00",
                  "Y-m-d H:i:s"
                ),
                showLoader: false,
              },
              () => {
                this.fetchMaterialTypesRaw();
              }
            );
            this.fetchSortedWasteList();
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showAddWasteByMassUpload: false,
            agent_id: "",
            route_id: "",
            date: null,
            time: formatDate(
              formatDate(new Date(), "Y-m-d") + " 00:00:00",
              "Y-m-d H:i:s"
            ),
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };
    const handleCopyToClipboard = (text: string) => {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          toast.success("Copied to clipboard!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .catch((error) => {
          console.error("Failed to copy to clipboard:", error);
          toast.error("Failed to copy to clipboard", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };
    const handleEditEntry = (entry: any) => {
      // if(entry.kind_of_sorted_wastes === "massupload"){

      //     this.setState({
      //         material_types_raw:{}
      //     })

      //     this.fetchMaterialTypesRaw();

      //     let materialTypes = this.state.material_types_raw;
      //     newURL
      //     .post(`getSortedWasteByMassUpload`, {
      //       id : entry.id,
      //     } , {
      //       headers: { "Content-Type": "application/json" },
      //     })
      //     .then((response: any) => {
      //       if (response.data) {
      //        response.data.data.forEach((key: any) => {

      //         for(let obj in materialTypes) {
      //             for(let subObj in materialTypes[obj].SubVal){
      //              console.log(materialTypes[obj].SubVal[subObj]);
      //              console.log(key);
      //              if(key.sorted_waste_for_storage_type_id == materialTypes[obj].SubVal[subObj].subTypesOfMaterialEntry ){
      //                 materialTypes[obj].SubVal[subObj].quantity = key.quantity;
      //                 materialTypes[obj].SubVal[subObj].edit_uuid = key.edit_uuid;
      //              }
      //             }
      //          }
      //        })
      //        this.setState({
      //         showLoader: false,
      //         entryId: entry.id,
      //         date: entry.created_at,
      //         time: entry.created_at,
      //         material_types_raw : materialTypes,
      //         });
      //      }
      // })

      // this.setState({
      //     showAddWasteByMassUpload:true,
      //     route_id: (entry.route_id) ? this.state.routes.findIndex((route) => (route.id == entry.route_id && route.hierarchy_id == entry.hierarchy_id && (route.type == "multiple_routes" || route.type == "route"))): "",
      //     agent_id: entry.sorting_agent_id,
      //     date: entry.created_at,
      //     time: entry.created_at,
      // })

      // }else {
      this.setState({
        showAddWasteByRawMaterial: true,
        entryId: entry.id,
        route_id: entry.route_id
          ? this.state.routes.findIndex(
              (route) =>
                route.id == entry.route_id &&
                route.hierarchy_id == entry.hierarchy_id &&
                (route.type == "multiple_routes" || route.type == "route")
            )
          : "",
        waste_quantity: entry.weight,
        unit: entry.unit_id,
        agent_id: entry.sorting_agent_id,
        material: entry.material,
        types: this.state.material_types[entry.material],
        material_type: entry.type_id,
        date: entry.created_at,
        time: entry.created_at,
        description: entry.description,
      });
      // }
    };

    const handleDeleteEntry = () => {
      this.setState({ showLoader: true });
      let data = {
        id: this.state.sortedWasteId,
      };
      newURL
        .post(`deleteSortedWaste`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          this.setState({
            showDeleteDialog: false,
            sortedWasteId: "",
            showLoader: false,
          });
          toast.success(t("Entry Deleted Successfully"), {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          this.fetchSortedWasteList();
        })
        .catch((error) => {
          this.setState({
            showDeleteDialog: false,
            sortedWasteId: "",
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const columns: any = [
      {
        headerName: "Id",
        field: "id",
        width: 80,
      },
      {
        headerName: t("Community"),
        field: "route",
        width: 150,
        renderCell: (params: GridCellParams) => (
          <Link
            to={`/routes/${params.row.route_id}`}
            style={{ textDecoration: "none" }}
          >
            {params.row.route}
          </Link>
        ),
      },
      {
        headerName: t("Material"),
        field: "material",
        width: 150,
      },
      {
        headerName: t("Type"),
        field: "type",
        width: 200,
      },
      {
        headerName: t("Weight"),
        field: "weight",
        width: 80,
        renderCell: (params: GridCellParams) => (
          <div>{parseFloat(params.row.weight.toString()).toLocaleString()}</div>
        ),
      },
      {
        headerName: t("Unit"),
        field: "unit",
        width: 80,
      },
      {
        headerName: t("Sorting Agent"),
        field: "sorting_agent",
        width: 150,
      },
      // {
      //     headerName: "Id",
      //     field: "id",
      //     width: 80
      // },
      {
        headerName: "Waste Insert Type",
        field: "kind_of_sorted_wastes",
        width: 150,
      },
      {
        headerName: t("Created At"),
        field: "created_at",
        type: "dateTime",
        width: 170,
        renderCell: (params: GridCellParams) => (
          <div>
            {params.row.created_at}
            {/* <IconButton
                            aria-label="copy"
                            onClick={() => handleCopyToClipboard(params.row.created_at)}
                        >
                            <FileCopyIcon />
                        </IconButton> */}
          </div>
        ),
      },
      // {
      //     headerName: t("UpdatedAt"),
      //     field: "updated_at",
      //     type: "dateTime",
      //     width: 150
      // },
      {
        headerName: t("Actions"),
        field: "actions",
        type: "actions",
        getActions: (params: GridRowParams) => [
          <GridActionsCellItem
            // icon={<FileCopyIcon />}
            label={t("Edit Sorted Waste")}
            onClick={() => handleEditEntry(params.row)}
            showInMenu
          />,
          <GridActionsCellItem
            label={t("Delete")}
            onClick={() =>
              this.setState({
                sortedWasteId: params.id.toString(),
                showDeleteDialog: true,
              })
            }
            showInMenu
          />,
        ],
      },
    ];

    return (
      <div>
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
          open={this.state.showLoader}
          // onClick={() => this.setState({ showLoader: false })}
        >
          <CircularProgress className="customLoader" />
        </Backdrop>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
<DiversionHeader user={this.props.user} />
        <Grid container spacing={2}>
          <Grid item md={12} xs={12} className="mt-3">
            <Card>
              <CardHeader
                title={
                  <Grid container spacing={2}>
                    <Grid item md={3} xs={12}>
                      <Typography
                        variant="h5"
                        className="MuiCardHeader-title"
                        sx={{ lineHeight: "40px" }}
                      >
                        {t("Diverted Waste")}
                      </Typography>
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <FormControl fullWidth={true} size="small">
                        <TextField
                          id="filter-input"
                          label={t("Search")}
                          name="filter"
                          value={this.state.filter}
                          onChange={(e: any) =>
                            this.setState({ filter: e.target.value }, () =>
                              this.fetchSortedWasteList()
                            )
                          }
                          fullWidth={true}
                          size="small"
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <FormControl fullWidth={true} size="small">
                        <InputLabel id="routes-select-label">
                          {t("Community")}
                        </InputLabel>
                        <Select
                          labelId="routes-select-label"
                          value={this.state.filter_route_id}
                          onChange={(e) =>
                            this.setState(
                              { filter_route_id: e.target.value },
                              () => this.fetchSortedWasteList()
                            )
                          }
                          displayEmpty
                          label={t("Community")}
                          fullWidth={true}
                        >
                          <MenuItem key={"all"} value={"all"}>
                            {t("All")}
                          </MenuItem>
                          {this.state.routes.map((route, key) => {
                            if (route.type == "hierarchy") {
                              return (
                                <MenuItem key={key} value={key} disabled={true}>
                                  {route.route}
                                </MenuItem>
                              );
                            } else if (route.type == "multiple_routes") {
                              return (
                                <MenuItem key={key} value={key}>
                                  &nbsp;&nbsp;{route.route}
                                </MenuItem>
                              );
                            } else {
                              return (
                                <MenuItem key={key} value={key}>
                                  &nbsp;&nbsp;{route.route}
                                </MenuItem>
                              );
                            }
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <FormControl fullWidth={true} size="small">
                        <Button
                          variant="contained"
                          size="small"
                          sx={{ marginTop: "5px" }}
                          onClick={() =>
                            this.setState({
                              showCustomDateFilter: true,
                              durationType: "divertedWaste",
                            })
                          }
                        >
                          {t("Date Search")}
                        </Button>
                      </FormControl>
                    </Grid>
                  </Grid>
                }
                className="text-left"
                action={
                  // <IconButton aria-label="customer-more-options-button" sx={{ outline: 'none !important' }} onClick={(e: any) => handleMoreOptions(e)}>
                  //     <MoreHorizOutlined id="customer-more-options-button" sx={{ outline: 'none !important' }} />
                  //     <Menu
                  //         id="customer-more-options-menu"
                  //         aria-labelledby="customer-more-options-button"
                  //         anchorEl={this.state.anchorEl}
                  //         open={open}
                  //         onClose={() => this.setState({ anchorEl: null })}
                  //         anchorOrigin={{
                  //             vertical: 'top',
                  //             horizontal: 'left',
                  //         }}
                  //         transformOrigin={{
                  //             vertical: 'top',
                  //             horizontal: 'left',
                  //         }}
                  //     >
                  //         <MenuItem className='customMenuItem' onClick={() => this.setState({ anchorEl: null })}>Synchronise</MenuItem>
                  //         <MenuItem className='customMenuItem' onClick={() => this.setState({ anchorEl: null })}>Export List</MenuItem>
                  //         <MenuItem className='customMenuItem' onClick={() => this.setState({ anchorEl: null })}>Reset List</MenuItem>
                  //     </Menu>
                  // </IconButton>
                  <CardActions>
                    {/* <Button variant="contained" size="small" className="viewHistoricalCharts" sx={{ marginRight: "8px" }} component={Link} to={'/diverted-waste-charts'}>{t("View Historical Charts")}</Button> */}
                    <Button
                      variant="contained"
                      size="small"
                      sx={{ outline: "none !important" }}
                      onClick={() => this.setState({ showExportToCsv: true })}
                    >
                      {t("Export To CSV")}
                    </Button>
                  </CardActions>
                }
              />
              <CardActions>
                <Button
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() =>
                    this.setState({ showAddWasteByRawMaterial: true })
                  }
                >
                  <Add /> {t("Add Waste By Raw Material")}
                </Button>
                <Button
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() =>
                    this.setState({ showAddWasteByMassUpload: true })
                  }
                >
                  <Add /> {t("Mass Upload Sorted Waste")}
                </Button>
                {(
                  isEmailAllowed(this.props.user.email) 
                ) && (
                <Button
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  onClick={() => {
                    this.setState({ showMaterialGraph: true }, () => {
                      this.fetchSortedWasteTypeSummary();
                    });
                  }}
                >
                  Show Material Graph
                </Button>)}
              </CardActions>
              <CardContent>
                <DataGrid
                  aria-label={t("Diverted Waste List")}
                  columns={columns}
                  rows={this.state.sortedWasteList}
                  rowCount={this.state.rowCount}
                  pageSize={this.state.pageSize}
                  onPageChange={(page) => this.fetchSortedWasteList(page)}
                  onPageSizeChange={(newPageSize) => {
                    this.setState({ pageSize: newPageSize });
                    this.fetchSortedWasteList(0, newPageSize);
                  }}
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  autoHeight={true}
                  pagination
                  components={{
                    MoreActionsIcon: EditOutlined,
                    // Toolbar: CustomToolbar
                    Pagination: () => (
                      <CustomPagination
                        count={Math.ceil(
                          this.state.rowCount / this.state.pageSize
                        )}
                        page={this.state.currentPage + 1}
                        onChange={(event, page) =>
                          this.fetchSortedWasteList(page - 1)
                        }
                      />
                    ),
                  }}
                  paginationMode="server"
                  componentsProps={{
                    toolbar: {
                      csvOptions: { fileName: "Diverted-waste-list" },
                    },
                  }}
                  // checkboxSelection
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Modal
          open={this.state.showAddWasteByRawMaterial}
          onClose={() => this.setState({ showAddWasteByRawMaterial: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card
              component={"form"}
              onSubmit={(event: any) => handleAddWasteByRawMaterial(event)}
            >
              <CardHeader
                title={
                  !this.state.entryId
                    ? t("Add Waste By Raw Material")
                    : t("Edit Entry")
                }
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() =>
                      this.setState({ showAddWasteByRawMaterial: false })
                    }
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("Date") + " *"}
                          value={this.state.date}
                          onChange={(newValue: any) => {
                            this.setState({ date: newValue });
                          }}
                          disableFuture={true}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <TimePicker
                          inputFormat="HH:mm"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("Time")}
                          value={this.state.time}
                          onChange={(newValue: any) => {
                            this.setState({ time: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  {
                    // (!this.state.entryId) &&
                    <Grid item md={3} xs={12}>
                      <FormControl fullWidth={true}>
                        <InputLabel id="routes-select-label">
                          {t("Community")} *
                        </InputLabel>
                        <Select
                          labelId="routes-select-label"
                          value={this.state.route_id}
                          onChange={(e) =>
                            this.setState({ route_id: e.target.value })
                          }
                          displayEmpty
                          label={t("Community")}
                          fullWidth={true}
                        >
                          {this.state.routes.map((route, key) => {
                            if (route.type == "hierarchy") {
                              return (
                                <MenuItem key={key} value={key} disabled={true}>
                                  {route.route}
                                </MenuItem>
                              );
                            } else if (route.type == "multiple_routes") {
                              return (
                                <MenuItem key={key} value={key}>
                                  &nbsp;&nbsp;{route.route}
                                </MenuItem>
                              );
                            } else {
                              return (
                                <MenuItem key={key} value={key}>
                                  &nbsp;&nbsp;{route.route}
                                </MenuItem>
                              );
                            }
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                  }
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="material-select-label">
                        {t("Material")} *
                      </InputLabel>
                      <Select
                        labelId="material-select-label"
                        value={this.state.material}
                        onChange={(e) =>
                          this.setState({
                            material: e.target.value,
                            types: this.state.material_types[e.target.value],
                          })
                        }
                        displayEmpty
                        label={t("Material") + " *"}
                        fullWidth={true}
                      >
                        {Object.keys(this.state.material_types).map(function (
                          key
                        ) {
                          return (
                            <MenuItem key={key} value={key}>
                              {key}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="material-types-select-label">
                        {t("Type")} *
                      </InputLabel>
                      <Select
                        labelId="material-types-select-label"
                        value={this.state.material_type}
                        onChange={(e) =>
                          this.setState({ material_type: e.target.value })
                        }
                        displayEmpty
                        label={t("Type") + " *"}
                        fullWidth={true}
                      >
                        {this.state.types.map((type: any) => {
                          return (
                            <MenuItem key={type.id} value={type.id}>
                              {type.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="waste-quantity-input"
                      label={t("Waste Quantity") + " *"}
                      value={this.state.waste_quantity}
                      type="number"
                      onChange={(e: any) =>
                        this.setState({ waste_quantity: e.target.value })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="unit-label">{t("Unit")} *</InputLabel>
                      <Select
                        labelId="unit-label"
                        value={this.state.unit}
                        onChange={(e) =>
                          this.setState({ unit: e.target.value })
                        }
                        displayEmpty
                        label={t("Unit") + " *"}
                        fullWidth={true}
                      >
                        {this.state.units.map((unit) => {
                          return (
                            <MenuItem key={unit.id} value={unit.id}>
                              {unit.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="sorting-agent-select-label">
                        {t("Sorting Agent")} *
                      </InputLabel>
                      <Select
                        labelId="sorting-agent-select-label"
                        value={this.state.agent_id}
                        onChange={(e) =>
                          this.setState({ agent_id: e.target.value })
                        }
                        displayEmpty
                        label={t("Sorting Agent") + " *"}
                        fullWidth={true}
                      >
                        {this.state.sorting_agents.map((sorting_agent) => {
                          return (
                            <MenuItem
                              key={sorting_agent.id}
                              value={sorting_agent.id}
                            >
                              {sorting_agent.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={8} xs={12}>
                    <FormControl fullWidth={true}>
                      <TextField
                        id="description-input"
                        label={t("Description") + " (" + t("Optional") + ")"}
                        value={this.state.description}
                        onChange={(e: any) =>
                          this.setState({ description: e.target.value })
                        }
                        fullWidth={true}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => handleClearAddWasteByRawMaterial()}
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  type="submit"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                >
                  {!this.state.entryId ? t("Add") : t("Edit")} {t("Waste")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showAddWasteByMassUpload}
          onClose={() => this.setState({ showAddWasteByMassUpload: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card
              component={"form"}
              onSubmit={(event: any) => handleAddWasteByMassUpload(event)}
            >
              <CardHeader
                title={t("Add Waste By Mass Upload")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() =>
                      this.setState({ showAddWasteByMassUpload: false })
                    }
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <CardActions className="mb-3">
                  <FormControl fullWidth={true}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        inputFormat="yyyy-MM-dd"
                        renderInput={(props) => <TextField {...props} />}
                        label={t("Date") + " *"}
                        value={this.state.date}
                        onChange={(newValue: any) => {
                          this.setState({ date: newValue });
                        }}
                        disableFuture={true}
                      />
                    </LocalizationProvider>
                  </FormControl>
                  <FormControl fullWidth={true}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <TimePicker
                        inputFormat="HH:mm"
                        renderInput={(props) => <TextField {...props} />}
                        label={t("Time")}
                        value={this.state.time}
                        onChange={(newValue: any) => {
                          this.setState({ time: newValue });
                        }}
                      />
                    </LocalizationProvider>
                  </FormControl>
                  <FormControl fullWidth={true}>
                    <InputLabel id="routes-select-label">
                      {t("Community")} *
                    </InputLabel>
                    <Select
                      labelId="routes-select-label"
                      value={this.state.route_id}
                      onChange={(e) =>
                        this.setState({ route_id: e.target.value })
                      }
                      displayEmpty
                      label={t("Community") + " *"}
                      fullWidth={true}
                    >
                      {this.state.routes.map((route, key) => {
                        if (route.type == "hierarchy") {
                          return (
                            <MenuItem key={key} value={key} disabled={true}>
                              {route.route}
                            </MenuItem>
                          );
                        } else if (route.type == "multiple_routes") {
                          return (
                            <MenuItem key={key} value={key}>
                              &nbsp;&nbsp;{route.route}
                            </MenuItem>
                          );
                        } else {
                          return (
                            <MenuItem key={key} value={key}>
                              &nbsp;&nbsp;{route.route}
                            </MenuItem>
                          );
                        }
                      })}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth={true}>
                    <InputLabel id="sorting-agent-select-label">
                      {t("Sorting Agent")} *
                    </InputLabel>
                    <Select
                      labelId="sorting-agent-select-label"
                      value={this.state.agent_id}
                      onChange={(e) =>
                        this.setState({ agent_id: e.target.value })
                      }
                      displayEmpty
                      label={t("Sorting Agent") + " *"}
                      fullWidth={true}
                    >
                      {this.state.sorting_agents.map((sorting_agent) => {
                        return (
                          <MenuItem
                            key={sorting_agent.id}
                            value={sorting_agent.id}
                          >
                            {sorting_agent.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </CardActions>
                <Divider className="mb-3" />
                <Grid container>
                  <Grid item md={12} xs={12}>
                    <TableContainer
                      component={Paper}
                      sx={{
                        boxShadow: 3,
                        height: "320px !important",
                        overflowY: "scroll",
                      }}
                    >
                      <Table sx={{ minWidth: 600 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Waste Type")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Waste SubType")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Weight")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Unit")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Comments")}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Object.keys(this.state.material_types).map(
                            (item: any, key: number) => {
                              let types: any = this.state.material_types[item];
                              return types.map((type: any, subKey: number) => {
                                return (
                                  <TableRow key={type.id}>
                                    <TableCell
                                      sx={{ width: "15%" }}
                                      size="small"
                                    >
                                      {type.material}
                                    </TableCell>
                                    <TableCell
                                      sx={{ width: "25%" }}
                                      size="small"
                                    >
                                      {type.name}
                                    </TableCell>
                                    <TableCell
                                      sx={{ width: "20%" }}
                                      size="small"
                                    >
                                      <TextField
                                        id="weight-input"
                                        label={t("Weight")}
                                        type="number"
                                        value={
                                          this.state.material_types_raw[key]
                                            ? this.state.material_types_raw[
                                                key
                                              ]["SubVal"][subKey]["quantity"]
                                            : ""
                                        }
                                        onChange={(e: any) =>
                                          handleMassUploadDataChange(
                                            key,
                                            subKey,
                                            "quantity",
                                            e.target.value
                                          )
                                        }
                                        fullWidth={true}
                                        // InputProps={{
                                        //     inputProps: { min: 0 }
                                        // }}
                                      />
                                    </TableCell>
                                    <TableCell
                                      sx={{ width: "15%" }}
                                      size="small"
                                    >
                                      <FormControl fullWidth={true}>
                                        <InputLabel id="unit-label">
                                          {t("Unit")}
                                        </InputLabel>
                                        <Select
                                          labelId="unit-label"
                                          value={
                                            this.state.material_types_raw[key]
                                              ? this.state.material_types_raw[
                                                  key
                                                ]["SubVal"][subKey]["unit"]
                                              : ""
                                          }
                                          onChange={(e: any) =>
                                            handleMassUploadDataChange(
                                              key,
                                              subKey,
                                              "unit",
                                              e.target.value
                                            )
                                          }
                                          displayEmpty
                                          label={t("Unit")}
                                          fullWidth={true}
                                        >
                                          {this.state.units.map((unit) => {
                                            return (
                                              <MenuItem
                                                key={unit.id}
                                                value={unit.id}
                                              >
                                                {unit.name}
                                              </MenuItem>
                                            );
                                          })}
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                    <TableCell
                                      sx={{ width: "25%" }}
                                      size="small"
                                    >
                                      <TextField
                                        id="comments-input"
                                        label={t("Comments")}
                                        value={
                                          this.state.material_types_raw[key]
                                            ? this.state.material_types_raw[
                                                key
                                              ]["SubVal"][subKey]["description"]
                                            : ""
                                        }
                                        onChange={(e: any) =>
                                          handleMassUploadDataChange(
                                            key,
                                            subKey,
                                            "description",
                                            e.target.value
                                          )
                                        }
                                        fullWidth={true}
                                      />
                                    </TableCell>
                                  </TableRow>
                                );
                              });
                            }
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() =>
                    this.setState({ showAddWasteByMassUpload: false })
                  }
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  type="submit"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                >
                  {t("AddWaste")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showExportToCsv}
          onClose={() => this.setState({ showExportToCsv: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title={t("Export Data")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showExportToCsv: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("From Date")}
                          value={this.state.fromDate}
                          onChange={(newValue: any) => {
                            this.setState({ fromDate: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("To Date") + " *"}
                          value={this.state.toDate}
                          onChange={(newValue: any) => {
                            this.setState({ toDate: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showExportToCsv: false })}
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  disabled={!this.state.fromDate || !this.state.toDate}
                  onClick={() => handleExportToCsv()}
                >
                  {t("Download")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showCustomDateFilter}
          onClose={() => this.setState({ showCustomDateFilter: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title={t("Select Custom Analytics Dates")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="close"
                    component="span"
                    onClick={() =>
                      this.setState({ showCustomDateFilter: false })
                    }
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          views={["year", "month", "day"]}
                          renderInput={(props) => <TextField {...props} />}
                          label={t("From Date") + " *"}
                          value={this.state.customFromDate}
                          onChange={(newValue: any) =>
                            this.setState({ customFromDate: newValue })
                          }
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          views={["year", "month", "day"]}
                          renderInput={(props) => <TextField {...props} />}
                          label={t("To Date") + " *"}
                          value={this.state.customToDate}
                          onChange={(newValue: any) =>
                            this.setState({ customToDate: newValue })
                          }
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showCustomDateFilter: false })}
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  disabled={
                    !this.state.customFromDate || !this.state.customToDate
                  }
                  onClick={() => {
                    this.setState({ showCustomDateFilter: false });
                    this.fetchSortedWasteList(0);
                  }}
                >
                  {t("Get Analytics")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
                <Modal
                  open={this.state.showMaterialGraph}
                  onClose={() => this.setState({ showMaterialGraph: false })}
                >
                  <Box sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: '85%',
                      maxHeight: '90vh',   
                      overflowY: 'auto',  
                      bgcolor: 'white',
                      p: 3
                  }}>
                      
                      {/* TITLE */}
                      <Typography variant="h6" sx={{ mb: 2 }}>
                        Sorted Waste Report
                      </Typography>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, alignItems: "center" }}>
                        <ButtonGroup variant="contained" className="diversionButtonGroup">
                          <Button
                            className={this.state.graphViewType === "material" ? "active" : ""}
                            onClick={() =>
                              this.setState({ graphViewType: "material" }, () =>
                                this.fetchSortedWasteTypeSummary()
                              )
                            }
                          >
                          {this.state.dateFilterLoading && this.state.graphViewType === "material" ? (
                            <CircularProgress size={20} style={{ color: '#204D36' }} />
                          ) : (
                            'Material'
                          )}
                          </Button>

                          <Button
                            className={this.state.graphViewType === "date" ? "active" : ""}
                            onClick={() =>
                              this.setState({ graphViewType: "date" }, () =>
                                this.fetchSortedWasteTypeSummary()
                              )
                            }
                          >
                          {this.state.dateFilterLoading && this.state.graphViewType === "date" ? (
                            <CircularProgress size={20} style={{ color: '#204D36' }} />
                          ) : (
                            'Time'
                          )}
                          </Button>
                        </ButtonGroup>
                        <ButtonGroup variant="contained" className="diversionButtonGroup float-right">

                          {/* TODAY */}
                          <Button
                            className={this.state.graphDuration === 'today' ? 'active' : ''}
                            onClick={() => {
                              const today = format(new Date(), "yyyy-MM-dd");

                              this.setState(
                                {
                                  graphDuration: 'today',
                                  customFromDate: today,
                                  customToDate: today
                                },
                                () => this.fetchSortedWasteTypeSummary()
                              );
                            }}
                          >
                          {this.state.dateFilterLoading && this.state.graphDuration === 'today' ? (
                            <CircularProgress size={20} style={{ color: '#204D36' }} />
                          ) : (
                            'Today'
                          )}
                          </Button>

                          {/* WEEK */}
                          <Button
                            className={this.state.graphDuration === 'week' ? 'active' : ''}
                            onClick={() => {
                              const start = format(startOfWeek(new Date(), { weekStartsOn: 1 }), "yyyy-MM-dd");
                              const end = format(endOfWeek(new Date(), { weekStartsOn: 1 }), "yyyy-MM-dd");

                              this.setState(
                                {
                                  graphDuration: 'week',
                                  customFromDate: start,
                                  customToDate: end
                                },
                                () => this.fetchSortedWasteTypeSummary()
                              );
                            }}
                          >
                            {this.state.dateFilterLoading && this.state.graphDuration === 'week' ? (
                              <CircularProgress size={20} style={{ color: '#204D36' }} />
                            ) : (
                              'Week'
                            )}
                          </Button>

                          {/* CURRENT MONTH */}
                          <Button
                            className={this.state.graphDuration === 'current_month' ? 'active' : ''}
                            onClick={() => {
                              const start = format(startOfMonth(new Date()), "yyyy-MM-dd");
                              const end = format(endOfMonth(new Date()), "yyyy-MM-dd");

                              this.setState(
                                {
                                  graphDuration: 'current_month',
                                  customFromDate: start,
                                  customToDate: end
                                },
                                () => this.fetchSortedWasteTypeSummary()
                              );
                            }}
                          >
                          {this.state.dateFilterLoading && this.state.graphDuration === 'current_month' ? (
                            <CircularProgress size={20} style={{ color: '#204D36' }} />
                          ) : (
                            'Current Month'
                          )}
                          </Button>

                          {/* LAST MONTH */}
                          <Button
                            className={this.state.graphDuration === 'month' ? 'active' : ''}
                            onClick={() => {
                              const lastMonth = subMonths(new Date(), 1);
                              const start = format(startOfMonth(lastMonth), "yyyy-MM-dd");
                              const end = format(endOfMonth(lastMonth), "yyyy-MM-dd");

                              this.setState(
                                {
                                  graphDuration: 'month',
                                  customFromDate: start,
                                  customToDate: end
                                },
                                () => this.fetchSortedWasteTypeSummary()
                              );
                            }}
                          >
                          {this.state.dateFilterLoading && this.state.graphDuration === 'month' ? (
                            <CircularProgress size={20} style={{ color: '#204D36' }} />
                          ) : (
                            'Last Month'
                          )}
                          </Button>

                          {/* CUSTOM */}
                          <Button
                            className={this.state.graphDuration === 'custom' ? 'active' : ''}
                            onClick={() => {
                              this.setState({ graphDuration: 'custom', showGraphCustom: true });
                            }}
                          >
                            Custom
                          </Button>

                        </ButtonGroup>
                      </Box>      
                      {/* HIGHCHART */}
                     {/* HIGHCHART / LOADER */}
                      {this.state.graphLoading ? (
                        <Box
                          sx={{
                            height: 400,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <CircularProgress className="customLoader" />
                        </Box>
                      ) : (
                        // <div id="incomingGraphContainer" style={{ height: 400 }} />
                        <Box sx={{ maxHeight: 500, overflowY: "auto" }}>
                          <div id="incomingGraphContainer" />
                        </Box>
                      )}             
                      {/* CLOSE BUTTON */}
                      <IconButton 
                        onClick={() => this.setState({ showMaterialGraph: false })}
                        sx={{ position: "absolute", top: 10, right: 10 }}
                      >
                        <CloseOutlined />
                      </IconButton>
                  </Box>
                </Modal>
                <Modal
          open={this.state.showGraphCustom}
          onClose={() => this.setState({ showGraphCustom: false })}
        >
          <Box sx={style}> 
            <Card>
              <CardHeader
                title="Select Date Range"
                action={
                  <IconButton onClick={() => this.setState({ showGraphCustom: false })}>
                    <CloseOutlined />
                  </IconButton>
                }
              />

              <CardContent>
                <Divider className="mb-3" />

                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          views={['year', 'month', 'day']}
                          mask="____-__-__"
                          label="From Date"
                          value={this.state.graphCustomFromDate}
                          onChange={(newValue: any) => {
                            this.setState({ graphCustomFromDate: newValue });
                          }}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          views={['year', 'month', 'day']}
                          mask="____-__-__"
                          label="To Date"
                          value={this.state.graphCustomToDate}
                          onChange={(newValue: any) => {
                            this.setState({ graphCustomToDate: newValue });
                          }}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                </Grid>

                <Divider className="mt-3" />
              </CardContent>

              <CardActions className="float-right">
                <Button 
                  size="small" 
                  onClick={() => this.setState({ showGraphCustom: false })}
                >
                  Close
                </Button>

                <Button
                  size="small"
                  variant="contained"
                  disabled={!this.state.graphCustomFromDate || !this.state.graphCustomToDate}
                  onClick={() => {
                    this.setState(
                      {
                        customFromDate: this.state.graphCustomFromDate,
                        customToDate: this.state.graphCustomToDate,
                        showGraphCustom: false
                      },
                      () => this.fetchSortedWasteTypeSummary()
                    );
                  }}
                >
                {this.state.dateFilterLoading ? (
                  <CircularProgress size={20} style={{ color: '#204D36' }}/>
                ) : (
                  'Apply'
                )}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Dialog
          open={this.state.showDeleteDialog}
          onClose={() => this.setState({ showDeleteDialog: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("Are you sure ? You want to delete this Entry ?")}
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => this.setState({ showDeleteDialog: false })}>
              {t("Cancel")}
            </Button>
            <Button onClick={() => handleDeleteEntry()} autoFocus>
              {t("Ok")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withRouter(withTranslation()(DivertedWaste));
